var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRecording(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M39.5897 38.0717H24.4105C21.059 38.0717 18.3389 35.3516 18.3389 32C18.3389 28.6485 21.059 25.9283 24.4105 25.9283C27.7621 25.9283 30.4822 28.6485 30.4822 32C30.4822 33.1051 30.1862 34.1433 29.6686 35.0358H34.3316C33.814 34.1433 33.518 33.1051 33.518 32C33.518 28.6485 36.2381 25.9283 39.5897 25.9283C42.9413 25.9283 45.6614 28.6485 45.6614 32C45.6614 35.3516 42.9413 38.0717 39.5897 38.0717ZM24.4105 28.9642C26.0863 28.9642 27.4464 30.3242 27.4464 32C27.4464 33.6758 26.0863 35.0358 24.4105 35.0358C22.7348 35.0358 21.3747 33.6758 21.3747 32C21.3747 30.3242 22.7348 28.9642 24.4105 28.9642ZM39.5897 28.9642C41.2655 28.9642 42.6255 30.3242 42.6255 32C42.6255 33.6758 41.2655 35.0358 39.5897 35.0358C37.9139 35.0358 36.5539 33.6758 36.5539 32C36.5539 30.3242 37.9139 28.9642 39.5897 28.9642Z",
    fill: "currentcolor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRecording);
export default __webpack_public_path__ + "static/media/recording.9159b2a5.svg";
export { ForwardRef as ReactComponent };